import React from 'react';
import {get} from 'lodash/fp';

import {Rank} from '/constant/TestIDs';
import {
  ASSOCIATE_DIRECTOR,
  DIRECTOR,
  EXECUTIVE_DIRECTOR,
  INTEGRATED_EXECUTIVE_DIRECTOR,
  MANAGER,
  SENIOR_COACH,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

import PeopleData from '../../PeopleData';
import PeopleExtendedData from '../../PeopleExtendedData';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.orderingEntities.${key}`, value);

export default {
  dataComponent: PeopleData,
  dataComponentProps: {
    getPeople: get('clients'),
    getTitle: (target: any) => {
      return target <= 1
        ? tt('title.incomplete.singular', 'Ordering Entity')
        : tt('title.incomplete.plural', 'Ordering Entities');
    },
    personIsCoach: false,
  },
  extendedDataComponent: PeopleExtendedData,
  extendedDataComponentProps: {
    getPeople: get('clients'),
    personIsCoach: false,
    getVacantName: ({avatarNumber}: any) =>
      tt(
        'vacancyPosition',
        generateComponentCallback({component: <>Client {avatarNumber}</>}),
      ),
    getVacancyCta: null,
    getPersonDescription: ({activatedOn}: any) =>
      tt(
        'position',
        generateComponentCallback({
          component: (
            <>
              Client since{' '}
              {getDateUtilDefaultInstance().formatDate(
                activatedOn,
                'MMMM d, yyyy',
              )}
            </>
          ),
        }),
      ),
    getPersonStats: null,
    onVacancyCtaPress: null,
  },
  isComplete: ({currentCount: current, target}: any) => current >= target,
  hasExtendedDetail: true,
  presentedFor: [
    SENIOR_COACH,
    MANAGER,
    DIRECTOR,
    EXECUTIVE_DIRECTOR,
    ASSOCIATE_DIRECTOR,
    INTEGRATED_EXECUTIVE_DIRECTOR,
  ],
  testID: Rank.rankOrderingEntities,
};
